import { UserInfo } from '@/types/Auth'
import { DataFilters } from '@/types/Dashboard'

export default {
  namespaced: true,
  state: {
    userInfo: UserInfo,
    mapLayoutSidebar: false,
    reportsFilters: new DataFilters(),
    lockReportFilters: false,
    visibleFiltersElements: {
      datesRangeSelector: false,
      dateSelector: false,
      dateSelector30Days: false,
      groupSelector: false,
      templateSelector: false
    },
    userGroupsDictionary: {}
  },
  mutations: {
    /* USER ***************************************************/
    setUserInfo (state: any, userInfo: UserInfo) {
      state.userInfo = userInfo
    },
    /* TRACKING ***********************************************/
    toggleMapLayoutSidebar (state: any) {
      state.mapLayoutSidebar = !state.mapLayoutSidebar
    },
    /* DASHBOARD **********************************************/
    updateReportsFilters (state: any, filters: DataFilters) {
      state.reportsFilters = filters
    },
    lockReportFilters (state: any, flag: boolean) {
      state.lockReportFilters = flag
    },
    updateFiltersReportCapacidadProductividad (state: any) {
      state.visibleFiltersElements = {
        datesRangeSelector: true,
        dateTaskCreatedSelector: false,
        dateSelector30Days: false,
        groupSelector: true,
        templateSelector: true
      }
    },
    updateFiltersReportEstatusGestion (state: any) {
      state.visibleFiltersElements = {
        datesRangeSelector: false,
        dateTaskCreatedSelector: true,
        dateSelector30Days: false,
        groupSelector: true,
        templateSelector: true
      }
    },
    updateFiltersReportConexion (state: any) {
      state.visibleFiltersElements = {
        datesRangeSelector: false,
        dateTaskCreatedSelector: false,
        dateSelector30Days: true,
        groupSelector: true,
        templateSelector: false
      }
    },
    updateUserGroupsDictionary (state: any, userGroupsDictionary: any) {
      state.userGroupsDictionary = userGroupsDictionary
    }
  },
  actions: {}
}
